import React from 'react';

const TONES = {
  default: 'bg-slate-300',
  indigo: 'bg-brand-500',
  violet: 'bg-violet-500',
  green: 'bg-emerald-500',
  amber: 'bg-amber-500',
  red: 'bg-rose-500',
  sky: 'bg-sky-500',
};

// Vertical timeline. events: [{ title, detail?, ts?, tone?, icon?, right? }]
export default function Timeline({ events = [] }) {
  return (
    <ol className="relative">
      {events.map((e, i) => {
        const Icon = e.icon;
        return (
          <li key={i} className="relative pl-7 pb-4 last:pb-0">
            {i < events.length - 1 && <span className="absolute left-[9px] top-3.5 bottom-0 w-px bg-slate-200" />}
            <span className={`absolute left-1.5 top-1 h-3 w-3 rounded-full ring-4 ring-white ${TONES[e.tone] || TONES.default} flex items-center justify-center`}>
              {Icon && <Icon className="h-2 w-2 text-white" />}
            </span>
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="text-sm text-slate-800 leading-snug">{e.title}</div>
                {e.detail && <div className="text-xs text-slate-500 mt-0.5">{e.detail}</div>}
              </div>
              {(e.ts || e.right) && <div className="text-[11px] text-slate-400 whitespace-nowrap shrink-0">{e.right || e.ts}</div>}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
